'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Logo from '@/components/common/Logo';
import Button from '@/components/common/Button';

interface HeaderProps {
  isAuthenticated?: boolean;
  userType?: 'artist' | 'user' | 'admin' | null;
  userName?: string;
}

const Header = ({ isAuthenticated = false, userType = null, userName }: HeaderProps) => {
  const pathname = usePathname();

  const isActive = (path: string) => pathname === path;

  return (
    <header className="bg-mono-0 border-b border-mono-30 sticky top-0 z-40">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* ロゴ */}
          <Link href="/">
            <Logo size="md" />
          </Link>

          {/* ナビゲーション */}
          <nav className="flex items-center gap-6">
            {isAuthenticated ? (
              <>
                {/* 認証済みユーザー用ナビゲーション */}
                {userType === 'artist' && (
                  <>
                    <Link
                      href="/artist/dashboard"
                      className={`text-base font-noto-sans-jp leading-[1.4] hover:text-primary transition-colors ${
                        isActive('/artist/dashboard') ? 'text-primary font-bold' : 'text-mono-80'
                      }`}
                    >
                      ダッシュボード
                    </Link>
                    <Link
                      href="/artist/works"
                      className={`text-base font-noto-sans-jp leading-[1.4] hover:text-primary transition-colors ${
                        isActive('/artist/works') ? 'text-primary font-bold' : 'text-mono-80'
                      }`}
                    >
                      作品管理
                    </Link>
                    <Link
                      href="/artist/plans"
                      className={`text-base font-noto-sans-jp leading-[1.4] hover:text-primary transition-colors ${
                        isActive('/artist/plans') ? 'text-primary font-bold' : 'text-mono-80'
                      }`}
                    >
                      プラン管理
                    </Link>
                  </>
                )}

                {userType === 'user' && (
                  <>
                    <Link
                      href="/explore"
                      className={`text-base font-noto-sans-jp leading-[1.4] hover:text-primary transition-colors ${
                        isActive('/explore') ? 'text-primary font-bold' : 'text-mono-80'
                      }`}
                    >
                      探す
                    </Link>
                    <Link
                      href="/subscriptions"
                      className={`text-base font-noto-sans-jp leading-[1.4] hover:text-primary transition-colors ${
                        isActive('/subscriptions') ? 'text-primary font-bold' : 'text-mono-80'
                      }`}
                    >
                      購入プラン
                    </Link>
                    <Link
                      href="/library"
                      className={`text-base font-noto-sans-jp leading-[1.4] hover:text-primary transition-colors ${
                        isActive('/library') ? 'text-primary font-bold' : 'text-mono-80'
                      }`}
                    >
                      ライブラリ
                    </Link>
                  </>
                )}

                {/* ユーザーメニュー */}
                <div className="flex items-center gap-4 ml-4 pl-4 border-l border-mono-30">
                  <span className="text-sm text-mono-80 font-noto-sans-jp">
                    {userName || 'ユーザー'}
                  </span>
                  <Link href="/settings">
                    <Button buttonType="secondary" size="sm">
                      設定
                    </Button>
                  </Link>
                </div>
              </>
            ) : (
              <>
                {/* 未認証ユーザー用ナビゲーション */}
                <Link
                  href="/about"
                  className="text-base text-mono-80 font-noto-sans-jp leading-[1.4] hover:text-primary transition-colors"
                >
                  サービスについて
                </Link>
                <Link href="/user/login">
                  <Button buttonType="secondary" size="sm">
                    ログイン
                  </Button>
                </Link>
                <Link href="/user/signup">
                  <Button buttonType="primary" size="sm">
                    新規登録
                  </Button>
                </Link>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
